export default __webpack_public_path__ + "static/media/anteja.89522687.svg";